/* ============================================================================
   LUXURY MINIMAL THEME - JavaScript
   Interactive functionality for enhanced UX
   ============================================================================ */

function trackMetaPixel(eventName, params) {
  if (window.fbq && typeof window.fbq === 'function') {
    fbq('track', eventName, params || {});
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Announcement bar dismiss
  const announcementBar = document.querySelector('.announcement-bar[data-dismissible="true"]');
  if (announcementBar) {
    if (localStorage.getItem('announcementDismissed') === 'true') {
      announcementBar.classList.add('is-dismissed');
    }
    const closeBtn = announcementBar.querySelector('.announcement-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        announcementBar.classList.add('is-dismissed');
        localStorage.setItem('announcementDismissed', 'true');
      });
    }
  }

  // Mobile nav toggle
  const toggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      const open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
  }

  // Cart quantity update
  const quantityInputs = document.querySelectorAll('input[data-item]');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const quantity = this.value;
      const itemKey = this.getAttribute('data-item');
      updateCartItem(itemKey, quantity);
    });
  });

  // Meta Pixel product view and add-to-cart tracking
  const productPage = document.querySelector('.product-page');
  if (productPage) {
    const productTitle = document.querySelector('.product-title')?.textContent?.trim();
    const productPriceElement = document.querySelector('.product-pricing .sale-price, .product-pricing .price');
    const productPrice = productPriceElement ? productPriceElement.textContent.replace(/[^0-9.]/g, '') : '';
    const productId = document.getElementById('product-variant-id')?.value;

    trackMetaPixel('ViewContent', {
      content_name: productTitle || 'Product',
      content_ids: productId ? [productId] : [],
      content_type: 'product',
      value: productPrice ? parseFloat(productPrice) : 0,
      currency: 'USD'
    });

    const productForm = document.querySelector('.product-form');
    if (productForm) {
      productForm.addEventListener('submit', function() {
        trackMetaPixel('AddToCart', {
          content_name: productTitle || 'Product',
          content_ids: productId ? [productId] : [],
          content_type: 'product',
          value: productPrice ? parseFloat(productPrice) : 0,
          currency: 'USD'
        });
      });
    }
  }

  // Smooth scroll to sections
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Fade in animation on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animation = 'fadeIn 0.6s ease';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.product-card, .section-title').forEach(el => {
    observer.observe(el);
  });

  // Add fade-in animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);

  // Instant search (debounced fetch, parse HTML, show suggestions)
  const SEARCH_MIN = 2;
  const SEARCH_LIMIT = 8;

  function debounce(fn, wait) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function createSuggestionsContainer(input) {
    let container = input.parentElement.querySelector('.instant-search-suggestions');
    if (!container) {
      container = document.createElement('div');
      container.className = 'instant-search-suggestions';
      input.parentElement.style.position = input.parentElement.style.position || 'relative';
      input.parentElement.appendChild(container);
    }
    return container;
  }

  async function fetchSearchResults(query) {
    const url = `/search.json?q=${encodeURIComponent(query)}`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      const data = await res.json();
      if (!data || !data.results) return [];

      const out = data.results.slice(0, SEARCH_LIMIT).map(item => {
        if (item.product) {
          return {
            type: 'product',
            title: item.product.title,
            url: item.url,
            price: item.product.price,
            image: item.product.image
          };
        }
        return {
          type: 'link',
          title: item.title,
          url: item.url
        };
      });

      return out;
    } catch (err) {
      console.error('Search fetch error', err);
      return [];
    }
  }

  function bindInstantSearch(input) {
    const container = createSuggestionsContainer(input);

    const update = debounce(async function() {
      const q = input.value.trim();
      if (q.length < SEARCH_MIN) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }

      container.innerHTML = '<div class="instant-loading">Searching…</div>';
      container.style.display = 'block';
      const results = await fetchSearchResults(q);
      if (results.length === 0) {
        container.innerHTML = '<div class="instant-empty">No results</div>';
        return;
      }

      container.innerHTML = results.map(r => {
        if (r.type === 'product') {
          return `
            <a href="${r.url}" class="search-card instant-card">
              <div class="product-image">${r.image ? '<img src="' + r.image + '"/>' : '<div class="product-placeholder"></div>'}</div>
              <div class="product-meta"><div class="product-name">${r.title}</div><div class="product-price">${r.price}</div></div>
            </a>
          `;
        }
        return `<a href="${r.url}" class="search-result-item">${r.title}</a>`;
      }).join('');
    }, 300);

    input.addEventListener('input', update);
    input.addEventListener('focus', update);

    // close on outside click
    document.addEventListener('click', function(e) {
      if (!input.parentElement.contains(e.target)) {
        container.style.display = 'none';
      }
    });
  }

  // Bind to any search inputs present on the page
  document.querySelectorAll('.search-input').forEach(bindInstantSearch);

  // ── Variant selector (keeps hidden #product-variant-id in sync) ──────────
  const variantJson = document.getElementById('product-variants-json');
  const variantMoneyJson = document.getElementById('product-variants-money');
  const variantImageJson = document.getElementById('product-variants-image');
  const variantIdInput = document.getElementById('product-variant-id');
  const optionGroups = document.querySelectorAll('.product-form .option-buttons');
  const pricingEl = document.getElementById('product-pricing');
  const mainAtcButton = document.getElementById('main-atc-btn');
  const stickyAtcBar = document.getElementById('sticky-atc');
  const galleryImage = document.getElementById('gallery-main-image');

  if (variantJson && variantIdInput && optionGroups.length > 0) {
    const variants = JSON.parse(variantJson.textContent);
    const variantMoney = variantMoneyJson ? JSON.parse(variantMoneyJson.textContent) : {};
    const variantImages = variantImageJson ? JSON.parse(variantImageJson.textContent) : {};

    function findVariant() {
      const chosen = Array.from(optionGroups).map(group => group.querySelector('.option-btn.selected')?.dataset.value);
      return variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
    }

    function showVariantImage(variant) {
      const image = variantImages[variant.id];
      if (!galleryImage || !image || galleryImage.src === image.src) return;
      galleryImage.classList.add('gallery-image--fading');
      window.setTimeout(() => {
        galleryImage.src = image.src;
        galleryImage.alt = image.alt;
        galleryImage.classList.remove('gallery-image--fading');
      }, 200);
    }

    function updatePricing(variant) {
      const money = variantMoney[variant.id];
      if (!money) return;
      if (pricingEl) {
        pricingEl.innerHTML = money.compare_at_price
          ? `<span class="original-price">${money.compare_at_price}</span><span class="sale-price">${money.price}</span>`
          : `<span class="price">${money.price}</span>`;
      }
      const stickyPrice = stickyAtcBar?.querySelector('.sticky-atc-price');
      if (stickyPrice) {
        stickyPrice.innerHTML = money.compare_at_price
          ? `<s>${money.compare_at_price}</s>&nbsp;${money.price}`
          : money.price;
      }
    }

    function updateAvailability(variant) {
      if (mainAtcButton) {
        const label = variant.available ? mainAtcButton.dataset.availableLabel : mainAtcButton.dataset.unavailableLabel;
        mainAtcButton.textContent = label;
        mainAtcButton.disabled = !variant.available;
      }
      const stickyBtn = stickyAtcBar?.querySelector('.sticky-atc-btn');
      if (stickyBtn) {
        const label = variant.available ? stickyBtn.dataset.availableLabel : stickyBtn.dataset.unavailableLabel;
        stickyBtn.textContent = label;
        stickyBtn.disabled = !variant.available;
      }
    }

    optionGroups.forEach(group => {
      group.querySelectorAll('.option-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          const v = findVariant();
          if (v) {
            variantIdInput.value = v.id;
            showVariantImage(v);
            updatePricing(v);
            updateAvailability(v);
          }
        });
      });
    });
  }

  // ── Accordion ─────────────────────────────────────────────────────────────
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const open = item.classList.toggle('open');
      trigger.setAttribute('aria-expanded', open);
    });
  });

  // ── Sticky Add to Cart ────────────────────────────────────────────────────
  const stickyBar = document.getElementById('sticky-atc');
  const mainAtcBtn = document.getElementById('main-atc-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');

  if (stickyBar && mainAtcBtn) {
    window.addEventListener('scroll', () => {
      const r = mainAtcBtn.getBoundingClientRect();
      const inView = r.top < window.innerHeight && r.bottom > 0;
      stickyBar.classList.toggle('visible', !inView);
      stickyBar.setAttribute('aria-hidden', inView);
    }, { passive: true });
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      const form = document.querySelector('.product-form');
      if (!form) return;

      const saved = stickyBtn.textContent;
      stickyBtn.textContent = 'Adding…';
      stickyBtn.disabled = true;

      try {
        const res = await fetch('/cart/add', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error();
        stickyBtn.textContent = 'Added ✓';
        setTimeout(() => {
          stickyBtn.textContent = saved;
          stickyBtn.disabled = false;
        }, 1500);
      } catch {
        stickyBtn.textContent = saved;
        stickyBtn.disabled = false;
      }
    });
  }
});

// ── Newsletter Popup ──────────────────────────────────────────────────────────
(function () {
  const popup      = document.getElementById('newsletter-popup');
  const closeBtn   = document.getElementById('np-close');
  const form       = document.getElementById('np-form');
  const submitBtn  = document.getElementById('np-submit');
  const formWrap   = document.getElementById('np-form-wrap');
  const success    = document.getElementById('np-success');
  const finePrint  = document.getElementById('np-fine-print');
  const copyBtn    = document.getElementById('np-copy-btn');
  const copyText   = document.getElementById('np-copy-text');
  const codeEl     = document.getElementById('np-code');

  if (!popup) return;

  const STORAGE_KEY    = 'fc_newsletter_dismissed';
  const SUBSCRIBED_KEY = 'fc_newsletter_subscribed';
  const enabled        = popup.dataset.enabled !== 'false';
  const delayMs        = parseInt(popup.dataset.delay || '2000', 10);
  const redisplayDays  = parseInt(popup.dataset.redisplayDays || '30', 10);
  const hasCode        = !!codeEl;
  // Skip localStorage suppression inside the theme editor preview
  const inEditor       = window.Shopify && window.Shopify.designMode;

  if (!enabled) return;
  if (window.location.pathname === '/pages/newsletter') return;

  function isDismissedRecently() {
    if (inEditor) return false;
    if (localStorage.getItem(SUBSCRIBED_KEY)) return true;
    const ts = localStorage.getItem(STORAGE_KEY);
    if (!ts) return false;
    return Date.now() - parseInt(ts, 10) < redisplayDays * 86400000;
  }

  function openPopup() {
    popup.removeAttribute('hidden');
    requestAnimationFrame(() => popup.classList.add('np-visible'));
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closePopup(dismissed) {
    popup.classList.remove('np-visible');
    popup.addEventListener('transitionend', () => {
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }, { once: true });
    if (dismissed) localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  if (!isDismissedRecently()) {
    setTimeout(openPopup, delayMs);
  }

  closeBtn.addEventListener('click', () => closePopup(true));

  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup(true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hasAttribute('hidden')) closePopup(true);
  });

  // Copy discount code to clipboard
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      const code = codeEl.textContent.trim();
      navigator.clipboard.writeText(code).then(function () {
        copyText.textContent = 'Copied';
        copyBtn.classList.add('np-copied');
        setTimeout(function () {
          copyText.textContent = 'Copy';
          copyBtn.classList.remove('np-copied');
        }, 2000);
      });
    });
  }

  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      submitBtn.disabled = true;
      submitBtn.textContent = '…';

      try {
        const res = await fetch('/contact', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });

        if (res.ok) {
          formWrap.hidden = true;
          if (finePrint) finePrint.hidden = true;
          success.removeAttribute('hidden');
          localStorage.setItem(SUBSCRIBED_KEY, '1');
          // If no discount code, auto-close after a moment
          if (!hasCode) setTimeout(() => closePopup(false), 2800);
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || 'Subscribe';
        }
      } catch {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.label || 'Subscribe';
      }
    });
  }
})();

function updateCartItem(itemKey, quantity) {
  if (quantity <= 0) {
    quantity = 1;
  }
  
  const formData = new FormData();
  formData.append('quantity', quantity);
  formData.append('line', itemKey);
  
  fetch('/cart/change', {
    method: 'POST',
    body: formData
  })
  .then(response => response.text())
  .then(() => {
    location.reload();
  })
  .catch(error => console.error('Error updating cart:', error));
}
